import { styled } from '@mui/material/styles';
import { Box, Card, CardContent, Grid, Typography, Alert } from '@mui/material';

export const StyledCard = styled(Card)(({ theme }) => ({
  // Card por defecto
}));

export const StyledCardContent = styled(CardContent)(({ theme }) => ({
  // Padding ya viene por defecto de CardContent
}));

export const CardTitle = styled(Typography)(({ theme }) => ({
  marginBottom: theme.spacing(3),
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
  fontWeight: 600,
}));

export const StyledGrid = styled(Grid)(({ theme }) => ({
  // Grid ya tiene su propio spacing
}));

export const InfoBox = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(2),
}));

export const InfoLabel = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
  marginBottom: theme.spacing(0.5),
}));

export const InfoValue = styled(Typography)(({ theme }) => ({
  fontWeight: 600,
}));

export const StyledAlert = styled(Alert)(({ theme }) => ({
  marginTop: theme.spacing(3),
}));

export const AlertTitle = styled(Typography)(({ theme }) => ({
  fontWeight: 600,
  marginBottom: theme.spacing(1),
}));

export const AlertMessage = styled(Typography)(({ theme }) => ({
  // Typography por defecto
}));
